export const getConfig = () => ({
  publicRuntimeConfig: {
    assetPrefix: '/ustorethemes/AquaBlue',
    apiUrl: '/uStoreRestAPI',
    classicUrl: '/ustore',
    themeCustomizationUrl: '/uStoreThemeCustomizations',
    serverDomain: 'http://localhost:5000'
  }
})
